import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { BREAKPOINTS, GLOBAL, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT } from '@/constants';

const SmallStyles = css`
  font-family: ${GLOBAL.BASE_FONT_FAMILY};
  font-size: ${FONT_SIZE.X_SMALL};
  line-height: ${LINE_HEIGHT.BODY.X_SMALL};
  font-weight: ${FONT_WEIGHT.REGULAR};
  letter-spacing: normal;
  margin: 0;

  @media (min-width: ${BREAKPOINTS.SM}px) {
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${LINE_HEIGHT.BODY.SMALL};
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    font-size: ${FONT_SIZE.MEDIUM};
    line-height: ${LINE_HEIGHT.BODY.MEDIUM};
  }
`;

const Small = styled.p`
  ${SmallStyles}
`;

export { Small, SmallStyles };
